import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import { ERRORS_STACK_HEIGHT } from './constants';

export const StyledAlert = styled(Alert)`
  align-items: center;
  display: flex;
  margin-block: ${({ theme }) => theme.spacing(1)};
`;

export const StyledBox = styled(Box)`
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

export const StyledErrorsStack = styled(Stack)`
  border: 1px ${({ theme }) => theme.palette.error.main} solid;
  height: ${ERRORS_STACK_HEIGHT}px;
  margin-bottom: ${({ theme }) => theme.spacing(1)};
  padding-inline: ${({ theme }) => theme.spacing(1)};
  overflow-y: scroll;
`;

export const StyledTypography = styled(Typography)`
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};
`;
